<template>
  <v-container mt-0 fluid>
  
  <v-layout >
      <v-flex xs3>
  <v-radio-group v-model="approvedState" row>
      <v-radio 
        v-for="(btn,index) in radioBtns"
        :key="btn"
        :label="btn"
        :value="index"
      ></v-radio>
    </v-radio-group>
     </v-flex>
    <v-flex xs6 >
   <v-combobox
          v-model="keywordList"
          :items="keywords"
          label="Search by Keywords - select from list or add your own."
          multiple
          hide-selected
          deletable-chips
          chips
        ></v-combobox>
        
       </v-flex>
        </v-layout>
    <v-layout v-for="content in contents" :key="content.id" fill-height v-if="matchesKey(content) && showApproved(content)">
      <v-flex xs12 mb-3 >
      
         
          <v-container fluid pa-2>
            <v-layout >
              <v-flex xs5 sm4 md3>
                <v-responsive>
                <video v-if="content.videoUrl && false"
                  :src="content.videoUrl"
                  height="130px" controls :poster="content.imageUrl" preload="none"
                ></video>
                <img  v-if="!content.videoUrl || true" @click="showDetails(content)" :src="content.imageUrl" height="200">
                
                </v-responsive>
               <div v-if="content.type=='title'" class="titlePreview">
                        <div class=pTitle>{{content.title}}</div>
                        <div class=pSubtitle>{{content.subtitle}}</div>
                        <div class=pBody>{{content.body}}</div>
                        <div class=pFooter>{{content.footer}}</div>
                      </div>
              </v-flex>
              <v-flex xs7 sm8 md9 >
              <v-card class="card" flat>
              
                <v-layout row fill-height style="min-height:82px">
                <v-flex xs4 >
                  <v-card-title primary-title class="pt-0" color="teal">
                  <div>
                  <h3 class="balck--text  mb-0">{{ content.title}}</h3>
                  <div><b>Artist:</b> {{content.artist }}</div>
                  <div><b>Type:</b> {{content.type }}</div>
                  <div v-if="content.type=='web'" ><a :href="content.web" target="_blank">{{content.web }}</a></div>
                  <div @click="getContact(content.creatorId)" style="cursor:pointer;"><b>Contact:</b> {{content.creatorId }}</div>
                  
                  </div>
                  </v-card-title>
                  
                </v-flex>
                <v-flex xs5 sm4 md5>
                <div ><b>Description:</b><span>{{content.description }}</span> 
             </div>
                <b></b>
                
                <v-chip v-if="!content.allowEdit"  small v-for="word in content.keywords" :key="word">
                 {{word}}
                </v-chip small> 
                 <v-combobox v-if="content.allowEdit"
                    v-model="content.keywords"
                    :items="keywords"
                    multiple
                    hide-selected
                    deletable-chips
                    chips
                  ></v-combobox>
                  <br>
                 <v-radio-group v-model="content.scaleMode" :disabled="!content.allowEdit" row style="display: inline-block;">
                Scale Content&nbsp;&nbsp;&nbsp;
                <v-radio label="None" value="none"></v-radio>
                <v-radio label="Fit" value="fit"></v-radio>
                <v-radio label="Fill" value="fill"></v-radio>
              </v-radio-group>


                
                  
                    
                     
                  
                </v-flex>
                <v-flex xs5 sm4 md3>
                <div><i>Uploaded: {{ content.date | date }}</i></div>
                <div><i>Expires: never</i></div>
                <div @click="clickPlay"><i>{{playval}} plays</i></div>
                  
                </v-flex>
                
                </v-layout>
               <v-footer color="transparent" relative >
               <v-chip small>
                {{ secondsToDurationText(content.duration) }}
              </v-chip small>
              <v-text-field v-if="content.allowEdit" v-model="content.duration" style="max-width:100px;flex:none"></v-text-field>
             
               <v-chip small v-if="content.looping">
                <v-icon>loop</v-icon>
              </v-chip small>
               <v-chip small v-if="content.approved">
                <v-icon @click="disapproveContent(content)">check_circle</v-icon>
              </v-chip small>
               <v-chip small  v-else>
                <v-icon @click="approveContent(content)">all_out</v-icon>
              </v-chip small>

                <v-chip small v-if="!content.allowEdit && content.rating">
                <v-icon v-for="r in content.rating">star</v-icon>
                <v-icon v-for="e in (5-content.rating)">star_border</v-icon>
              </v-chip small>
              <v-chip v-if="content.allowEdit" ><v-rating v-model="content.rating" color="#757575"></v-rating></v-chip>
               
             
               <v-spacer></v-spacer>




             
       
               <app-view-content-details-dialog   :videoUrl="content.videoUrl" :imageUrl="content.imageUrl" :content="content">
                    </app-view-content-details-dialog>
                 <v-btn  v-if="!content.allowEdit"  @click="allowEdit(content)" flat fab absolute right icon small color="indigo" style="right:180px">
              <v-icon>edit</v-icon></v-btn>
               <v-btn v-if="content.allowEdit"  @click="doEdit(content)" flat fab absolute right icon small color="indigo" style="right:180px">
              <v-icon color="green">edit</v-icon></v-btn>
             
              </v-footer>
                </v-card>
                <div v-if="content.allowEdit">[ Content ID:{{content.id}} ] [ Creator ID:{{ content.creatorId }} ] [ Video: {{ content.videoUrl }} ] [ Image: {{ content.imageUrl }} ]</div>
              </v-flex>
            </v-layout>
            
          </v-container>
        </v-card>
      </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import * as firebase from 'firebase'
 export default {
   data () {
     return {
       radioBtns:['Show All','approved','pending'],
       approvedState:0,
       playvalX:'',
       date: null,
       menu: false,
       showEmail:false,
       //keywords: ['Action','Drama','Animation'],
       keywordList:[],
       keywords: [
          'Animation',
          'MyState',
          'Student',
          'Stories in September',
          'TAC',
          'TAHO',
          'Tasmanian Artist',
          'The Loop',
          'Title',        
          'UTAS',
          'Visual Art',
          'Wide Angle', 
          'Test'
        ],
     }
   },
   components: {
    
  },
  created(){
      if(this.contents.length==0){
        this.$store.dispatch('loadContents');
      }
      
    },
    mounted(){



    },
   computed: {
    
     playval () {
      return this.$store.getters.getControlsPlay
     },
     contents () {
       console.log("CONTENTS",this.$store.getters.loadedContents[0])
       return this.$store.getters.loadedContents
       
     }
   },
   methods:{
    showDetails(content){
      console.log("ShowDetails")
      window.open(content.videoUrl, '_blank');
      //this.$set(content,'showDetails',true);
      //console.log("ShowDetails",content)
    },
     getContact(userId){
       this.$store.dispatch("getContact",userId).then(response => {
            console.log(response)
             alert ("Email : " + response)
            return response
        }, error => {
            console.error("No Data")
            return "no email confirmed"
        })
     },
     
     showApproved(content){
       switch(this.approvedState){
         case 0: return true
         break
         case 1: return content.approved
         break
         case 2: return !content.approved
         break
       }
     },
     doEdit(content){
       console.log("EDIT CONTENT",content)
       this.$set(content,'allowEdit',false);
       this.$store.dispatch('updateContentData',content);
     },
     allowEdit(content){
       console.log("allowEdit")
       this.$set(content,'allowEdit',true);
      
     },
     addKeyword(content){
       console.log("Add Keyword",content)
     },
      approveContent(content){
        content.approved=true;
       this.$store.dispatch('updateContentData',content);
       console.log("Approve",content)
     },
     disapproveContent(content){
       content.approved=false;
       this.$store.dispatch('updateContentData',content);
       console.log("Approve",content)
     },
     matchesKey(element){
     // console.log( this.keywordList,element.keywords)
      if(this.keywordList.length==0){
        return true;
      }
      if(this.keywordList[0]=="None" && !element.keywords){
        return true;
      }
      if(!element.keywords){
        return false;
      }
      return this.findOne(element.keywords,this.keywordList)
    },
    findOne (haystack, arr) {
            return arr.some(function (v) {
                return haystack.indexOf(v) >= 0;
            });
    },
     remove (item) {
        this.chips.splice(this.chips.indexOf(item), 1)
        this.chips = [...this.chips]
      },
    clickPlay(){
      this.$store.dispatch('setControlsPlay');
    },
    secondsToDurationText(sec){
        var hrs=Math.floor(sec/(60*60));
        var mins=Math.floor((sec-hrs*60*60)/60);
        var secs=Math.floor(sec%60);
        var time="";
        if(hrs>0){time=hrs+"hour"+this.plural(hrs)+" "}
        if(mins>0){time=time+mins+"min"+this.plural(mins)+" "}
        if(secs>0){time=time+secs+"sec"+this.plural(secs)+" "}
        return time
      },
      plural(val){
        if(val!=1){
          return "s"
        }else{
          return ""
        }
      }
   }
 }
</script>
<style scoped>
.v-rating .v-icon {
    padding: 0!important;
    color:#676767!important;
}
.v-rating .accent--text{
  color:#676767!important;
}
</style>


// WEBPACK FOOTER //
// src/components/Content/Contents.vue